import superAdminRoutes from 'routes/routesByRole/adminRoutes';

export default superAdminRoutes;
